module.exports = __webpack_public_path__ + "img/code.b3c804e5.png";